// mission-secrets-test-env-run-preflight.ts — phase 04a (spec V2 §4.2 (5), N33).
//
// - Preflight `run` (gọi trước dispatch đầu tiên, trước machine lock): quyền/
//   owner sai, file không an toàn/không đọc được, hoặc có key `ANTHROPIC_*`
//   (review 04a L7 — doctor FAIL mục này thì `run` phải chặn thật) ⇒ chặn.
//   Vắng file ⇒ qua (mission không dùng secret thử).
// - Lệnh chỉ đọc (`status`): quyền sai ⇒ CẢNH BÁO, vẫn render (N33, review L6).
// Thông điệp chỉ đường dẫn + tên key, không giá trị.
import { loadMissionTestEnv, missionSecretsDir } from "./mission-secrets-test-env-loader.js";

export type MissionTestEnvRunPreflight = { ok: true } | { ok: false; message: string };

const ANTHROPIC_PREFIX = "ANTHROPIC_";

export async function preflightMissionTestEnvForRun(
  missionId: string,
): Promise<MissionTestEnvRunPreflight> {
  const result = await loadMissionTestEnv(missionId);
  if (result.status === "absent") return { ok: true };
  if (result.status === "ok") {
    const anthropic = Object.keys(result.values).filter((k) => k.startsWith(ANTHROPIC_PREFIX));
    if (anthropic.length === 0) return { ok: true };
    return {
      ok: false,
      message:
        `test.env của mission ${missionId} có key ${anthropic.join(", ")} — chưa dispatch. ` +
        `Key ANTHROPIC_* bị cấm forward (cùng luật env worker); xoá khỏi ${result.path} rồi chạy lại.`,
    };
  }
  const reason =
    result.status === "invalid_permissions"
      ? result.problems.join("; ")
      : `không đọc được (${result.detail})`;
  return {
    ok: false,
    message:
      `test.env của mission ${missionId} sai quyền/owner — chưa dispatch: ${reason}. ` +
      `Sửa: chmod 700 ${missionSecretsDir(missionId)} && chmod 600 ${result.path} ` +
      "(file thường, owner = account chạy `run`), rồi chạy lại.",
  };
}

/** `status`: một dòng cảnh báo khi `test.env` sai quyền/không đọc được; ổn/vắng ⇒ `undefined`. */
export async function missionTestEnvWarningForReadOnlyCommand(
  missionId: string,
): Promise<string | undefined> {
  const result = await loadMissionTestEnv(missionId);
  if (result.status === "invalid_permissions") {
    return `test.env sai quyền/owner (vẫn được che khi hiển thị): ${result.problems.join("; ")}`;
  }
  if (result.status === "unreadable") {
    return `không đọc được ${result.path} (${result.detail}) — giá trị trong file chưa chắc được che`;
  }
  return undefined;
}
